// extracted by mini-css-extract-plugin
export default {"container":"CardContentComponent_container__+d+92","count":"CardContentComponent_count__qoRiM"};